import type { Theme } from '@mui/material/styles';

export interface ResolvedMuiThemeContext {
  theme: Theme;
  mode: 'light' | 'dark';
  toggleTheme: () => void;
}

const noopToggleTheme = (): void => {
  /* Duplicate-chunk / missing provider: theme reads still work via MUI ThemeProvider. */
};

/**
 * Resolve our theme context, falling back to MUI's ThemeProvider theme.
 *
 * Lazy homepage chunks can import a second copy of MuiThemeContext after a deploy
 * (ST-2026-156). Throwing there blanks the articles section; MUI tokens remain valid.
 */
export function resolveMuiThemeContext(
  context: ResolvedMuiThemeContext | undefined,
  muiTheme: Theme,
  options?: { strict?: boolean },
): ResolvedMuiThemeContext {
  if (context !== undefined) {
    return context;
  }
  if (options?.strict) {
    throw new Error('useMuiTheme must be used within a MuiThemeContextProvider');
  }
  return {
    theme: muiTheme,
    mode: muiTheme.palette?.mode === 'dark' ? 'dark' : 'light',
    toggleTheme: noopToggleTheme,
  };
}
